
<div class="header-left-section">
  <a [routerLink]="UrlConstants.buildUrl(UrlConstants.DASHBOARD)" class="text-link app-logo-container">
    <img src="assets/img/Logo_TX Manager.svg" class="header-logo-img" alt="ID Issuer" />
  </a>

  <div class="nav-links">
    <span class="pipe-symbol"><b>|</b></span> 
    <a *ngIf="canViewTaxLevels()" [routerLink]="UrlConstants.buildUrl(UrlConstants.TAX_LEVELS)" routerLinkActive="active" class="nav-link">{{ 'sidebar.tax.taxLevels' | translate }}</a>
    
    <ng-container *ngIf="canViewApprovals()">
      <span class="pipe-symbol"><b>|</b></span> 
      <a [routerLink]="UrlConstants.buildUrl(UrlConstants.APPROVALS)" routerLinkActive="active" class="nav-link approval-link">
        {{ 'sidebar.approvals.entities' | translate }}
        <span *ngIf="approvalCount > 0" class="approval-badge">{{approvalCount > 9 ? '9+' : approvalCount}}</span>
      </a>
    </ng-container>

    <!-- <ng-container *ngIf="canViewConfiguration()">
      <span class="pipe-symbol"><b>|</b></span> 
      <a [routerLink]="UrlConstants.buildUrl(UrlConstants.SETTINGS)" routerLinkActive="active" class="nav-link">Configuration</a>
    </ng-container> -->
  </div>
</div>

<div class="header-right-section">
  <!-- Notification Section - Only show for standard users -->
  <div *ngIf="isStandardUser()" class="notification-wrapper">
    <!-- Notification Bell Icon -->
    <mat-icon 
      class="text-link notification-icon notification-bell" 
      [class.has-unread]="unreadCount > 0"
      [class.mat-badge-plus]="unreadCount > 9"
      [matBadge]="unreadCount > 9 ? '9' : unreadCount" 
      [matBadgeHidden]="unreadCount === 0" 
      matBadgeColor="warn" 
      (click)="onNotificationClick()">
      notifications_active
    </mat-icon>

    <!-- Notification Dropdown -->
    <div *ngIf="showNotifications" class="notification-dropdown">
      <div class="notification-header">
        <div class="notification-title-wrapper">
          <span class="ws-indicator" 
                [class.connected]="isNotificationWSConnected" 
                [title]="isNotificationWSConnected ? ('headerNotifications.connected' | translate) : ('headerNotifications.disconnected' | translate)">
          </span>
          <h4>
            <span>{{ 'headerNotifications.title' | translate }}</span>
            <span class="notification-count">({{ unreadNotifications.length }})</span>
          </h4>
        </div>
        <div class="header-actions">
          <button 
            *ngIf="unreadNotifications.length > 0" 
            class="mark-all-read-btn" 
            (click)="markAllAsRead()"
            [disabled]="isMarkingAllAsRead">
            {{ isMarkingAllAsRead ? ('headerNotifications.marking' | translate) : ('headerNotifications.markAllRead' | translate) }}
          </button>
          <button class="close-btn" (click)="closeNotifications()">×</button>
        </div>
      </div>
      
      <div class="notification-content">
        <div *ngIf="unreadNotifications.length === 0" class="no-notifications">
          <p>{{ 'headerNotifications.noNotifications' | translate }}</p>
        </div>
        
        <ul *ngIf="unreadNotifications.length > 0" class="notification-list">
          <li *ngFor="let notification of unreadNotifications" class="notification-item">
            <div class="notification-content-item">
              <div class="notification-text">
                <p class="notification-title"><strong>{{ translateNotificationText(notification.title || 'headerNotifications.defaultTitle') }}</strong></p>
                <p class="notification-message">{{ translateNotificationText(notification.message || notification.content || 'headerNotifications.noMessage') }}</p>
                <span class="notification-time">{{ formatNotificationTime(notification.createdAt || notification.timestamp) }}</span>
              </div>
              <div class="notification-actions">
                <button 
                  class="mark-read-btn" 
                  (click)="markAsRead(notification)"
                  [disabled]="notification.isMarking"
                  [title]="'headerNotifications.markAsRead' | translate">
                  <mat-icon *ngIf="!notification.isMarking">check</mat-icon>
                  <mat-icon *ngIf="notification.isMarking" class="spinning">hourglass_empty</mat-icon>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- User Profile Section -->
  <div class="user-profile-container">
    <div class="user-profile-wrapper">
      <div class="user-info" (click)="toggleUserDropdown()">
        <span class="user-name">{{ authService.user?.First_Name }} {{ authService.user?.Last_Name }}</span>
      </div>
      <div class="user-avatar" (click)="toggleUserDropdown()">
        {{ getInitials() }}
      </div>
    
      <!-- User Dropdown -->
      <div *ngIf="showUserDropdown" class="user-dropdown">
        <div class="rightdropdoown">
          <div class="user-avatar" (click)="toggleUserDropdown()"> {{ getInitials() }} </div>
          <span class="user-nameD">{{ authService.user?.First_Name }} {{ authService.user?.Last_Name }}</span>
        </div>
        
        <div style="padding: 15px 20px; line-height: 30px;">
          <button (click)="openUserProfile()" class="dropdown-item">
              {{ 'header.userProfile' | translate }}
          </button>
          <button (click)="openChangePassword()" class="dropdown-item">
              {{ 'header.changePassword' | translate }}
          </button>
          <div class="dropdown-divider"></div>
          <button (click)="logout()" class="dropdown-item">
              {{ 'header.logout' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>